import { ReactNode, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';
import { Conditional } from '@cat-ecom/pcc-components';
import { CatCheckboxField } from 'blocks-nextjs/blocks-react/components/CheckboxField';
import styles from './style.module.scss';
import { CatFieldNote } from 'blocks-nextjs/blocks-react/components/FieldNote';

interface Props {
  dealerName: string;
  name: string;
  label: string;
  fieldNote: ReactNode;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  showCheckbox?: boolean;
  className?: string;
}

export const TermsAndConditionsCheckbox = ({
  dealerName,
  name,
  label,
  fieldNote,
  checked = false,
  required = false,
  disabled = false,
  showCheckbox = true,
  className = ''
}: Props) => {
  const { setValue, resetField, watch } = useFormContext();

  // * makes checkbox field as true when initialized
  useEffect(() => {
    if (checked) {
      setValue(name, checked);
    }

    return () => {
      resetField(name);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <Conditional test={showCheckbox}>
      <div className={cx(className, 'u-color--ExtraDarkGray mb-3')}>
        <CatCheckboxField
          required={required}
          disabled={disabled}
          onBlCheckboxChange={(e) => setValue(name, e.detail.checked)}
          checked={watch(name)}
        >
          <div
            className={cx(
              styles['padding-center'],
              'cat-u-theme-typography-label'
            )}
          >
            {label}
            <Conditional test={required}>
              <span className={styles['required-field']}>{' (required)'}</span>
            </Conditional>
          </div>
        </CatCheckboxField>
        <Conditional test={!!fieldNote}>
          <CatFieldNote>
            <span className="mt-1">{fieldNote}</span>
          </CatFieldNote>
        </Conditional>
      </div>
    </Conditional>
  );
};
